import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-assistanceaveragerespondtimemillis-card',
  templateUrl: './helpbutton-reports-assistanceaveragerespondtimemillis-card.component.html',
  styleUrls: ['./helpbutton-reports-assistanceaveragerespondtimemillis-card.component.scss']
})
export class HelpbuttonReportsAssistanceaveragerespondtimemillisCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() { }

}
